var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinfooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1125 2.1875C3.1125 3.05062 2.41875 3.75 1.5625 3.75C0.70625 3.75 0.0125 3.05062 0.0125 2.1875C0.0125 1.325 0.70625 0.625 1.5625 0.625C2.41875 0.625 3.1125 1.325 3.1125 2.1875ZM3.125 5H0V15H3.125V5ZM8.11375 5H5.00875V15H8.11438V9.75062C8.11438 6.83187 11.8825 6.59312 11.8825 9.75062V15H15V8.66812C15 3.74312 9.42375 3.9225 8.11375 6.34687V5Z",
    fill: "#5F6178"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinfooter);
export default __webpack_public_path__ + "static/media/linkedinfooter.1cef15eb.svg";
export { ForwardRef as ReactComponent };